/**
 * @generated SignedSource<<7252c0fb783ad39fe09b6cf4c22df185>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BookingStatus = "CONFIRMED" | "DRAFT";
import { FragmentRefs } from "relay-runtime";
export type useIsAnyDynamicRateOnBookingLocked_Booking$data = {
  readonly rounds?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly roundRate: {
          readonly rate: {
            readonly dynamicOverridden?: boolean;
          };
        } | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly status?: BookingStatus;
  readonly " $fragmentType": "useIsAnyDynamicRateOnBookingLocked_Booking";
};
export type useIsAnyDynamicRateOnBookingLocked_Booking$key = {
  readonly " $data"?: useIsAnyDynamicRateOnBookingLocked_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"useIsAnyDynamicRateOnBookingLocked_Booking">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useIsAnyDynamicRateOnBookingLocked_Booking",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RoundConnection",
          "kind": "LinkedField",
          "name": "rounds",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RoundEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RoundRate",
                      "kind": "LinkedField",
                      "name": "roundRate",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "rate",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "dynamicOverridden",
                                  "storageKey": null
                                }
                              ],
                              "type": "CustomerRate",
                              "abstractKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "StandardBooking",
      "abstractKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};

(node as any).hash = "7c4e62ffd3673bc0312e85a8521e339e";

export default node;
